import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { PixKey } from '../../models/key.model';
import { PixKeyType } from '../../models/key-type.enum';
import { PixMenu } from '../../models/pix-menu.enum';
import { PixKeysService } from '../../keys/keys.service';
import { AnimationKeyframesSequenceMetadata } from '@angular/core/src/animation/dsl';
import { PixReceivePaymentListChoiceComponent } from './choice-modal/choice-modal.component';
import { EventTypes } from '../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { Util } from '../../../../utils/util';
import { PixService } from '../../pix.service';
import { PixTransferRequest } from '../../models/transfer-request.model';
import { PixGenerateQrCode } from '../../models/generate-qrcode.model';

@Component({
	selector: 'app-pix-receive-payment-list',
	templateUrl: './list.component.html',
	styleUrls: ['./list.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixReceivePaymentListComponent implements OnInit {

	public dataSource: MatTableDataSource<PixKey>;
	public displayedColumns: Array<string> = ['tipoChave', 'codigo', 'others'];
	public list: PixKey[] = [];

	constructor(
		private pixKeysService: PixKeysService,
		private router: Router,
		public dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.getList();
	}

	getList() {
		this.list = [];

		this.pixKeysService.get().subscribe(result => {
			if (result && result.Existe && result.Sucesso) {
				this.list = Util.keysToCamel(result.Retorno) as PixKey[];
				this.dataSource = new MatTableDataSource(this.list);
			}
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	select(item: PixKey) {
		if (item) {
			const request = new PixGenerateQrCode(item.codigo, item.tipoChave, null, 'D', null, 'ESTATICO', null);
			this.pixKeysService.setPixGenerateQrCode(request);
			this.router.navigate(['pix/receber/simples']);
		}
	}

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	get pixMenu(): typeof PixMenu {
		return PixMenu;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/receive-payment/list/list.component.ts